<div>
    <pannel [title]="'Acc&egrave;s aux ouvrages et limitation du risque d&rsquo;interf&eacute;rence'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="accesOuvragesLimitations">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Conditions m&eacute;t&eacute;orologiques'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="conditionsMeteorologiques">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Obligation(s)'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="obligations">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Interdiction(s)'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="interdictions">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Travailleur isolé'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="travailleursIsoles">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Sous-traitance'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="sousTraitance">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Mise à jour du PDP'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="miseAjourPdp">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Sp&eacute;cificit&eacute;s du site'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="specificiteSite">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
    <pannel [title]="'Organisation des secours'" [expandable]="true" [folded]="true">
        <table mat-table class="consignes-securite-generales-table" [dataSource]="organisationSecours">
            <!-- Consignes -->
            <ng-container matColumnDef="consignes">
                <th mat-header-cell *matHeaderCellDef class="consignes-securite-generales-header-cell">Consignes : </th>
                <td mat-cell *matCellDef="let consignesSecurite">
                    <i class="fa fa-circle" style="font-size: 11px;margin-right: 6px;"></i>
                    {{consignesSecurite.consignes}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsConsignesSecuriteGenerales"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsConsignesSecuriteGenerales;"></tr>
        </table>
    </pannel>
</div>